export const lightBlue = {
  700: 'hsla(201, 98%, 41%, 1)',
};

export type LightBluePalette = typeof lightBlue;
